var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85463 0.146513C8.80773 0.100133 8.75241 0.0631374 8.69163 0.0375131C8.56921 -0.0125044 8.43205 -0.0125044 8.30963 0.0375131C8.24885 0.0631374 8.19353 0.100133 8.14663 0.146513L0.146631 8.14651C0.0527448 8.2404 0 8.36774 0 8.50051C0 8.63329 0.0527448 8.76063 0.146631 8.85451C0.240518 8.9484 0.367856 9.00114 0.500632 9.00114C0.633407 9.00114 0.760745 8.9484 0.854632 8.85451L8.00063 1.70651V16.4995C8.00063 16.6321 8.05331 16.7593 8.14708 16.8531C8.24085 16.9468 8.36802 16.9995 8.50063 16.9995C8.63324 16.9995 8.76042 16.9468 8.85419 16.8531C8.94795 16.7593 9.00063 16.6321 9.00063 16.4995V1.70651L16.1466 8.85351C16.2405 8.9474 16.3679 9.00014 16.5006 9.00014C16.6334 9.00014 16.7607 8.9474 16.8546 8.85351C16.9485 8.75963 17.0013 8.63229 17.0013 8.49951C17.0013 8.36674 16.9485 8.2394 16.8546 8.14551L8.85463 0.146513Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.b93e9f7b.svg";
export { ForwardRef as ReactComponent };